/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Location Marker (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgLocationMarker = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M47.657 46.657 43.414 50.9a1.997 1.997 0 0 1-2.827 0l-4.244-4.243a8 8 0 1 1 11.314 0" />
      <path d="M44.121 43.121a3 3 0 1 0-4.242-4.242 3 3 0 0 0 4.242 4.242" />
    </g>
  </svg>
);
export default SvgLocationMarker;
